interface HCMMenuProps {
  setDisplayValue: (val: number) => void;
  displayValue: number;
  clear: boolean;
  setClear: (val: boolean) => void;
  setIsFiltersOpen?: () => void;
}

const HCMMenu: React.FC<HCMMenuProps> = ({
  setDisplayValue,
  displayValue,
  setClear,
  clear,
  setIsFiltersOpen,
}) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setDisplayValue(Number(event.target.value));
    setClear(false);
    setIsFiltersOpen?.();
  };
  return (
    <ul>
      <li>
        <label className="label cursor-pointer justify-start ml-5">
          <input
            type="radio"
            className="radio radio-xs bg-white border-accent checked:radio-accent"
            value={60}
            checked={!clear && displayValue === 60}
            onChange={handleChange}
          />
          <span className="text-valmidnight text-base ml-2">Total </span>
        </label>
      </li>
      <li>
        <label className="label cursor-pointer justify-start ml-5">
          <input
            type="radio"
            className="radio radio-xs bg-white border-accent checked:radio-accent"
            value={61}
            checked={!clear && displayValue === 61}
            onChange={handleChange}
          />
          <span className="text-valmidnight text-base ml-2">
            Hospitilization{" "}
          </span>
        </label>
      </li>
      <li>
        <label className="label cursor-pointer justify-start ml-5">
          <input
            type="radio"
            className="radio radio-xs bg-white border-accent checked:radio-accent"
            value={62}
            checked={!clear && displayValue === 62}
            onChange={handleChange}
          />
          <span className="text-valmidnight text-base ml-2">
            Emergency Room{" "}
          </span>
        </label>
      </li>
      <li>
        <label className="label cursor-pointer justify-start ml-5">
          <input
            type="radio"
            className="radio radio-xs bg-white border-accent checked:radio-accent"
            value={63}
            checked={!clear && displayValue === 63}
            onChange={handleChange}
          />
          <span className="text-valmidnight text-base ml-2">Urgent Care</span>
        </label>
      </li>
      <li>
        <label className="label cursor-pointer justify-start ml-5">
          <input
            type="radio"
            className="radio radio-xs bg-white border-accent checked:radio-accent"
            value={64}
            checked={!clear && displayValue === 64}
            onChange={handleChange}
          />
          <span className="text-valmidnight text-base ml-2">Outpatient</span>
        </label>
      </li>
      <li>
        <label className="label cursor-pointer justify-start ml-5">
          <input
            type="radio"
            className="radio radio-xs bg-white border-accent checked:radio-accent"
            value={65}
            checked={!clear && displayValue === 65}
            onChange={handleChange}
          />
          <span className="text-valmidnight text-base ml-2">Pharmacy </span>
        </label>
      </li>
    </ul>
  );
};

export default HCMMenu;
